<div
  #bmarkEntryDefault
  fxFlex
  fxLayout="column"
  fxLayoutAlign="center"
  fxLayoutGap="5px"
  class="order-entry-settings__bmark__body"
>
  <!-- CLIENT -->
  <div fxFlex="1 1 100%" class="order-entry-settings__bmark__row">
    <ic-autocomplete-defaults
      #inputClient
      id="defaults_client"
      inputId="defaults_client"
      class="order-entry__panel-client-details__data-client"
      mode="client"
      [disabled]="data.client.disabled"
      [allowEmpty]="true"
      [constraint]="data.account.value"
      [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
      [(ngModel)]="data.client.value"
      (blur)="onClientChange($event)"
      (onTabChange)="onTabChange($event)"
      (onClientSelect)="onClientSelect($event)"
    >
    </ic-autocomplete-defaults>
    <!-- (ngModelChange)="onClientChange($event)" -->
  </div>
  <!-- ACCOUNT -->
  <div fxFlex="1 1 100%" class="order-entry-settings__bmark__row">
    <ic-autocomplete-defaults
      #inputAccount
      id="defaults_account"
      inputId="defaults_account"
      class="order-entry__panel-client-details__data-account"
      mode="account"
      [disabled]="data.account.disabled"
      [allowEmpty]="true"
      [constraint]="data.client.value"
      [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
      [(ngModel)]="data.account.value"
      (blur)="onAccountChange($event)"
      (onTabChange)="onTabChange($event)"
    >
    </ic-autocomplete-defaults>
    <!-- (ngModelChange)="onAccountChange($event)" -->
  </div>
  <!-- CCY PAIR / ORDER TYPE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__bmark__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <ic-ccy-pair-defaults
      fxFlex="1 1 50%"
      #inputCcyPair
      id="oe-defaults_bmark_ccy-pair"
      inputId="currencyPair"
      class="bfx-component-wrapper"
      [label]="data.currencyPair.label"
      [dataset]="data.currencyPair.dataset"
      [marketRateDisable]="true"
      [(ngModel)]="data.currencyPair.product"
      [allowEmpty]="true"
      (ngModelChange)="onCurrencyPairChange($event)"
    >
    </ic-ccy-pair-defaults>
    <ic-autocomplete-defaults
      fxFlex="1 1 50%"
      #inputOrderType
      id="defaults_order-type"
      inputId="defaults_order-type"
      mode="type"
      [allowEmpty]="true"
      [label]="data.orderType.label"
      disabled="true"
      [dataset]="data.orderType.dataset"
      [(ngModel)]="data.orderType.value"
      (ngModelChange)="onOrderTypeChange($event)"
      class="bfx-component-wrapper"
    >
    </ic-autocomplete-defaults>
  </div>

  <!-- CCY PAIR / TYPE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__bmark__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
    [style.display]="!control.showIntentAndAmount ? 'none' : 'inherit'"
  >
    <div
      fxFlex="1 1 50%"
      fxLayout="row"
      fxLayoutGap="4px"
      [style.padding-top]="0"
      class="bfx-component-wrapper"
    >
      <bfx-client-intent-toggle
        fxFlex="1 1 50%"
        #toggleClientIntent
        id="defaults_client-intent"
        inputId="defaults_client-intent"
        class="order-entry__panel-financials__client-intent"
        [label]="data.clientIntent.label"
        [(ngModel)]="data.clientIntent.value"
        (ngModelChange)="onClientIntentToggleChange($event)"
      >
      </bfx-client-intent-toggle>
      <ic-fixed-ccy
        fxFlex="1 1 50%"
        #toggleFixedCcy
        id="defaults_fixed-ccy"
        inputId="defaults_fixed-ccy"
        class="order-entry__panel-financials__fixed-ccy"
        [ccyPair]="data.fixedCcy.ccyPair"
        [(ngModel)]="data.fixedCcy.value"
        (ngModelChange)="onFixedCcyToggleChange($event)"
      >
      </ic-fixed-ccy>
    </div>
    <bfx-amount-spinner
      fxFlex="1 1 50%"
      #inputOrderAmount
      id="defaults_order-amount"
      inputId="defaults_order-amount"
      class="order-entry__panel-financials__order-amount bfx-component-wrapper"
      [label]="data.orderAmount.label"
      [mandatory]="false"
      [keyupAssignZero]="false"
      [minMaxTouchValid]="false"
      [currency]="data.fixedCcy.fixedCcy"
      [(ngModel)]="data.orderAmount.value"
      (ngModelChange)="onOrderAmountChange($event)"
      (blur)="onOrderAmountBlur($event)"
      [size]="'sm'"
    >
    </bfx-amount-spinner>
  </div>

  <!-- VALUE DATE / FIXING CODE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__bmark__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <!-- VALUE DATE -->
    <bfx-autoComplete
      fxFlex="1 1 50%"
      #inputValueDate
      id="defaults_value-date"
      inputId="defaults_value-date"
      class="interface-control__custom-input-autocomplete__container bfx-component-wrapper"
      [(ngModel)]="data.valueDate.value"
      [label]="data.valueDate.label"
      [suggestions]="data.valueDate.suggestions"
      [settingsCorrection]="true"
      [disabled]="data.valueDate.disabled"
      [autoHighlight]="true"
      [skipSorting]="true"
      delay="4"
      field="label"
      dataKey="value"
      [dropdown]="true"
      [allowEmptySelection]="true"
      [emptyIsInactive]="true"
      (ngModelChange)="valueDateOnBlur($event)"
      (completeMethod)="valueDateSuggestion($event)"
      [size]="'sm'"
      appendTo="body"
    >
    </bfx-autoComplete>
    <!-- FIXING SOURCE -->
    <div fxFlex="1 1 50%"></div>
  </div>

  <!-- VALUE DATE / FIXING CODE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__bmark__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <!-- FIXING SOURCE -->
    <bfx-autoComplete
      fxFlex="1 1 50%"
      #inputFixingCode
      id="defaults_fixing-code"
      inputId="defaults_fixing-code"
      class="interface-control__custom-input-autocomplete__container bfx-component-wrapper"
      [(ngModel)]="data.fixingSource.value"
      [label]="data.fixingSource.label"
      [suggestions]="data.fixingSource.suggestions"
      [settingsCorrection]="true"
      [disabled]="data.fixingSource.disabled"
      [autoHighlight]="true"
      [skipSorting]="true"
      delay="4"
      field="label"
      dataKey="value"
      [dropdown]="true"
      [allowEmptySelection]="true"
      [emptyIsInactive]="true"
      (completeMethod)="searchFixingSources($event)"
      (ngModelChange)="onFixingCodeBlur()"
      [size]="'sm'"
      appendTo="body"
    >
    </bfx-autoComplete>
    <!-- FIXING TIME -->
    <bfx-autoComplete
      #inputFixing
      id="defaults-control_fixing"
      inputId="fixing-input"
      class="interface-control__custom-input-autocomplete__container bfx-component-wrapper"
      target="fixing"
      delay="5"
      field="label"
      dataKey="label"
      [allowEmptySelection]="true"
      [emptyIsInactive]="true"
      [disabled]="data.fixing.disabled"
      [suggestions]="data.fixing.suggestions"
      [dropdown]="true"
      [label]="data.fixing.label"
      [minLength]="0"
      [maxlength]="50"
      [(ngModel)]="data.fixing.value"
      (completeMethod)="searchFixings($event)"
      (ngModelChange)="onFixingChange($event)"
      [size]="'sm'"
      appendTo="body"
    >
    </bfx-autoComplete>
  </div>

  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__bmark__row"
    [style.visibility]="data.privateOrder.show  ? 'visible': 'hidden'"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <ic-private-order-defaults
      fxFlex="1 1 50%"
      #inputPrivateOrder
      id="defaults_private-order"
      inputId="defaults_private-order"
      [loading]="control.isLoading"
      [label]="data.privateOrder.label"
      [(ngModel)]="data.privateOrder.value"
      (ngModelChange)="onPrivateOrderChange()"
    >
    </ic-private-order-defaults>
    <div fxFlex="1 1 50%"></div>
  </div>
</div>
